import React from 'react';
import { SUPPORT_EMAIL, SOCIAL_PROFILE } from '../data/offer';
const links = [SUPPORT_EMAIL, SOCIAL_PROFILE, 'Termini e condizioni', 'Privacy policy', 'Cookie policy'];
export function Footer() {
  return <footer className="w-full bg-sage-dark text-white" data-id="element-109" data-mp="32p5nojgp12qd">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 text-center" data-id="element-110" data-mp="36pfvm1o1q37v">
        <p className="font-serif font-bold text-lg sm:text-xl" data-id="element-111" data-mp="36nd57gize82m">
          Il Sistema Completo del Coach™
        </p>
        <p className="mt-3 text-white/80 text-sm sm:text-base" data-id="element-112" data-mp="38qvoyiyxrr6">
          Il sistema operativo completo per i coach che si rifiutano di
          improvvisare il percorso di qualcun altro.
        </p>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm" data-id="element-113" data-mp="3qdf2v2jeis8j">
          {links.map(link => <li key={link} data-id="element-114" data-mp="29ynlrlrph7ej">
              <a href="#" className="text-white/75 hover:text-white underline decoration-white/30 hover:decoration-white transition-colors" data-id="element-115" data-mp="29ydwk0ehj49w">
                {link}
              </a>
            </li>)}
        </ul>

        <p className="mt-8 text-xs leading-relaxed text-white/50 max-w-2xl mx-auto" data-id="element-116" data-mp="3gaz1n2bhmjjk">
          Il coaching non è una prestazione sanitaria né psicoterapeutica. Per
          situazioni di natura clinica ci si rivolge a uno psicologo o
          psicoterapeuta iscritto all&apos;albo. Nessun risultato è garantito.
          Attività professionale non organizzata in ordini o collegi ai sensi
          della Legge 4/2013.
        </p>
        <p className="mt-4 text-xs text-white/50" data-id="element-117" data-mp="33e71cf6sut9">
          © 2026 Il Sistema Completo del Coach™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}